import React, { useState, useEffect } from "react";
import GlobalStyles from 'styles/GlobalStyles';
import SignUp from './components/Signup.js';
import Login from './components/Login.js';
import RestaurantLandingPage from './components/RestaurantLandingPage.js';
import TermsOfService from './components/TermsOfService.js';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Boutique from "components/Boutique.js";
import './Boutique.css';
import './ProductDetails.css';
import './Checkout.css';
import './App.css';
import Point from "components/Admin/points.jsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import ProductDetails from "components/ProductDetails.js";
import CheckoutFrom from "components/CheckoutForm.js";
import ForgotPassword from "components/ForgotPassword.js";
import ResetPassword from "components/ResetPassword.js";
import Orders from "components/Admin/Orders.jsx";
import Profile from "components/Admin/Profile.js";
import OrdersAdmin from "components/AdminDashbord/Orders.jsx";
import ProduitsAdmin from "components/AdminDashbord/Produits.jsx";
import DashbordAdmin from "components/AdminDashbord/Dashbord.jsx";
import PaymentAdmin from "components/AdminDashbord/Payment.jsx";
import UserAdmin from "components/AdminDashbord/UserAdmin.jsx";
import ClientAdmin from "components/AdminDashbord/ClientAdmin.jsx";
import Retraite from "components/AdminDashbord/Retraite.jsx";
import StockManagement from "components/Gestion/EditPrice.jsx";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute component
import Contact from "Contact.js";
import AboutLadyCosmeticos from "components/propos.jsx";
import './i18n'; // <-- this runs the i18n config
import LanguageSwitcher from "components/LanguageSwitcher.jsx";
import i18n from "./i18n"; // adjust path if needed
import AdminAnnouncement from "components/AdminDashbord/AdminAnnouncement.jsx";
import AnnouncementBanner from "components/AnnouncementBanner.jsx";
import WhatsAppButton from "components/WhatsAppButton.jsx";
import BlogPage from "./components/BlogPage";
import BlogDetail from "./components/BlogDetail";
import GestionProduits from "components/Gestion/Produits.jsx";
import EditStock from "components/Gestion/EditStock.jsx";
import EditPrice from "components/Gestion/EditPrice.jsx";
import ClientsGestion from "components/Gestion/Client.jsx";
import Caisse from "components/Gestion/Caisse.jsx";
import GestionCredit from "components/Gestion/GestionCredit.jsx";
import DashbordGestion from "components/Gestion/Dashbord.jsx";
import Historique from "components/Gestion/Historique.jsx";
import Facture from "components/Gestion/Facture.jsx";
import Bon from "components/Gestion/Bone.jsx";

import RapportPerformance from "components/Gestion/RapportPerformance.jsx";

import Parametres from "components/Gestion/Parametres.jsx";
import Devis from "components/Gestion/Devis.jsx";
import Cadeaux from "components/cards/Cadeaux.jsx";
import Librairie from "components/cards/Librairie.jsx";
import Electromenager from "components/cards/Electromenager.jsx";
import Accessoires from "components/cards/Accessoires.jsx";
import Montres from "components/cards/Montres.jsx";
import ComplementCosmetique from "components/cards/ComplementCosmetique.jsx";
import Parfums from "components/cards/Parfums.jsx";
import Chaussures from "components/cards/Chaussures.jsx";
import Textile from "components/cards/Textile.jsx";
import Bijou from "components/cards/Bijou.jsx";
import Construction from "components/cards/Construction.jsx";
import ProduitsNaturels from "components/cards/ProduitsNaturels.jsx";
import OrderConfirmation from "components/OrderConfirmation.jsx";
import Delivery from "components/AdminDashbord/Delivery.jsx";
import ClientChat from "components/ClientChat.js";
import AdminChat from "components/AdminDashbord/AdminChat.js";
export default function App() {
  const [role, setRole] = useState(null);
  // PageWrapper component (declared inside App so it can use hooks)
  const PageWrapper = ({ children }) => {
    const location = useLocation();
    // list here the routes that should receive the left margin
  const pathsToOffset = ['/Bon','/Edit-stock','/RapportPerformance', '/Edit-price', '/Stock_Management', '/Gestion_Produit', '/clientgestions', '/gestion-credit', '/Caisse', '/dashbord-gestion', '/historique', '/facturations', '/parametres', '/devis'];
    const shouldOffset = pathsToOffset.some(p => location.pathname === p || location.pathname.startsWith(p + '/'));
    const classes = [];
    if (shouldOffset) classes.push('app-with-sidebar');
    
    return <div className={classes.join(' ')}>{children}</div>;
  };
  useEffect(() => {
    const handler = (lng) => {
      const currentLang = lng || i18n.language;
      const dir = currentLang === "ar" ? "rtl" : "ltr";
      document.documentElement.setAttribute("dir", dir);
      document.documentElement.setAttribute("lang", currentLang);
    };
    handler(i18n.language);
    i18n.on('languageChanged', handler);
    return () => i18n.off('languageChanged', handler);
  }, []);
  useEffect(() => {
    const storedRole = localStorage.getItem('isAdmin'); 
    if (storedRole !== null) {
      setRole(storedRole);
    } else {
      setRole(''); 
    }
  }, []);
  if (role === null) {
    return <div>Loading...</div>;
  }
  
  return (
    <>
     <LanguageSwitcher />

      <GlobalStyles />
      <Router>
        {/* PageWrapper applies the sidebar spacing only on configured routes */}
        {
          /* PageWrapper must be inside Router so useLocation works */
        }
        <PageWrapper>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<RestaurantLandingPage />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/Boutique" element={<Boutique/>} />
          <Route path="/à-props" element={<AboutLadyCosmeticos/>} />
          <Route path="/banner" element={<AnnouncementBanner/>} />
          <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/point" element={<Point />} />

         <Route
  path="/product-details/:idAndSlug"
  element={<ProductDetails />}
/>
          <Route
            path="/checkout"
            element={
                <CheckoutFrom />
            }
          />
            <Route
            path="/ClientChat"
            element={
                <ClientChat />
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowedRoles={['0']}>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashbord-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <DashbordAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AdminChat"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <AdminChat  />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Stock_Management"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <StockManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Gestion_Produit"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <GestionProduits />
              </ProtectedRoute>
            }
          />
              <Route
            path="/Edit-stock"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <EditStock />
              </ProtectedRoute>
            }
          />
              <Route
                path="/clientgestions"
                element={
                  <ProtectedRoute allowedRoles={['gestion_stock']}>
                    <ClientsGestion />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/gestion-credit"
                element={
                  <ProtectedRoute allowedRoles={['gestion_stock']}>
                    <GestionCredit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Edit-price"
                element={
                  <ProtectedRoute allowedRoles={['gestion_stock']}>
                    <EditPrice />
                  </ProtectedRoute>
                }
              />
                          <Route
                path="/caisse"
                element={
                  <ProtectedRoute allowedRoles={['gestion_stock']}>
                    <Caisse />
                  </ProtectedRoute>
                }
              />
                  <Route
            path="/admin-announcement"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <AdminAnnouncement/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashbord-gestion"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <DashbordGestion />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <OrdersAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/historique"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <Historique />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parametres"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <Parametres />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facturations"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <Facture />
              </ProtectedRoute>
            }
          />
 <Route
            path="/Bon"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <Bon />
              </ProtectedRoute>
            }
          />



          <Route
            path="/RapportPerformance"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <RapportPerformance />
              </ProtectedRoute>
            }
          />


          <Route
            path="/devis"
            element={
              <ProtectedRoute allowedRoles={['gestion_stock']}>
                <Devis />
              </ProtectedRoute>
            }
          />
          <Route
            path="/produits-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ProduitsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <PaymentAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <UserAdmin />
              </ProtectedRoute>
            }
          />
              <Route
            path="/Delivery"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Delivery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-admin"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <ClientAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/retraite"
            element={
              <ProtectedRoute allowedRoles={['1']}>
                <Retraite />
              </ProtectedRoute>
            }
          />
          {/* Category routes */}
<Route path="/cadeaux" element={<Cadeaux/>} />
<Route path="/librairie-papeterie" element={<Librairie/>} />
<Route path="/electromenager" element={<Electromenager/>} />
<Route path="/accessoires-telephone" element={<Accessoires/>} />
<Route path="/montres" element={<Montres/>} />
<Route path="/cosmetiques-complements" element={<ComplementCosmetique/>} />
<Route path="/parfums" element={<Parfums/>} />
<Route path="/chaussures" element={<Chaussures/>} />
<Route path="/textile-habillement" element={<Textile/>} />
<Route path="/bijoux" element={<Bijou/>} />
<Route path="/materiaux-construction" element={<Construction/>} />
<Route path="/produits-naturels" element={<ProduitsNaturels/>} />
        </Routes>
        <WhatsAppButton />
        </PageWrapper>
      </Router>

    </>
  );
}